import React from 'react';
import * as constants from '../../constants';

const footer = () => (
    <footer className="site-footer">
        <div className="site-footer-legal">
            Copyright &copy; {new Date().getFullYear()} <a href={constants.STL_URL} target="_blank" rel="noopener noreferrer">Software Technologies Limited</a>
        </div>
        <div className="site-footer-right">
            {constants.APP_VERSION}
        </div>
    </footer>
);

export default footer;